import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./AboutPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import MultiCarousel from "../../Common/LogoCarousel"
import {about_us,About_Us_Text} from "../../data";
import { Helmet } from 'react-helmet';
import Founder from "../../Common/Founder";



function App() {
  return (
  <X02AboutPageDesktop {...x02AboutPageDesktopData} />
  );
}

export default App;

function X02AboutPageDesktop(props) {
  const {
    text126,
    text1262,
    text1263,
    text1264,
    text1265,
    text1266,
    text1267,
    aboutUs,
    whyChooseUs,
    founders,
    line55,
    place,
    transparency,
    cost,
    place2,
    text128,
    transparenccy,
    text129,
    cost2,
    text130,
  } = props;

  return (

    <div className="apd-container-center-horizontal">
      <Helmet>
        <title>Webuildd Construction | About Us</title>
        <meta name="keywords" content="Quality construction company, transparent construction company, cost effective construction company, On-Time Completion, experienced builders, experienced architects, " />
        <meta name="description" content="Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency." />
      </Helmet>
      <div className="apd-x02-about-page-desktop">
        <div className="apd-overlap-group">
          <div className="apd-frame-1571">
            <div className="apd-frame-173">
              <div className="apd-overlap-group1">
                <div className="apd-text-1 apd-typographybody16-regular">
                  <p>{text126}</p>
                  <p>{text1262}</p>
                  <p>{text1263}</p>
                  <p>{text1264}</p>
                  <p>{text1265}</p>
                  <p>{text1266}</p>
                  <p>{text1267}</p>
                </div>
                <img className="apd-rectangle-76" src={about_us.AboutUsHeader} alt="Webuildd About Us" />
                <div className="apd-vision-mission">
                <p> Vision Statement : To accelerate and furnish your ideal space through quality innovation.</p>
          <p> Mission Statement : Constructing dreams transparently, at an effective cost with quality, just as we promised. </p>
                </div>
                <h1 className="apd-title valign-text-middle apd-typographyheadlineh2-extrabold-40">{aboutUs}</h1>
                <div className="apd-why-choose-us valign-text-middle apd-typographyheadlineh2-extrabold-40">{whyChooseUs}</div>
                <div className="apd-founders valign-text-middle apd-typographyheadlineh2-extrabold-40">{founders}</div>
                <Founder/>
                <div className="apd-group-154">
                  <div className="apd-overlap-group2">
                    <img className="apd-line-55" src={line55} />
                    <div className="apd-group-151">
                      <img 
                        src={about_us.AboutQualityIcon}
                      />
                      <div className="apd-place apd-valign-text-middle apd-typographyheadlineh4-extrabold-24">{place}</div>
                    </div>
                    <div className="apd-group-152">
                      <img
                      src={about_us.AboutTransparencyIcon}
                      />
                      <div className="apd-transparency apd-valign-text-middle apd-typographyheadlineh4-extrabold-24 ">
                        {transparency}
                      </div>
                    </div>
                  </div>
                  <div className="apd-group-153">
                    <img 
                    src={about_us.AboutCostIcon}
                    />
                    <div className="apd-cost apd-valign-text-middle apd-typographyheadlineh4-extrabold-24">{cost}</div>
                  </div>
                
                </div>
                
                {/* <div className="apd-frame-171">
                  <img className="apd-rectangle-77" src={rectangle77} />
                  <img className="apd-rectangle-77" src={about_us.AboutHowItWorks} /> 
                  <div className="apd-group-155">
                    <div className="apd-how-it-works apd-valign-text-middle apd-typographyheadlineh2-extrabold-40">
                      {howItWorks}
                    </div>
                    <p className="apd-text-2 apd-typographybody16-regular">{text127}</p>
                  </div>
                </div> */}
                {/* <img className="apd-rectangle-48" src={rectangle48} />
                <img className="apd-rectangle-49" src={rectangle49} />
                <img className="apd-rectangle-50" src={rectangle50} /> */}
                <img className="apd-rectangle-48" src={about_us.AboutQuality} alt="Webuildd Quality"/>
                <img className="apd-rectangle-49" src={about_us.AboutTransparency} alt="Webuildd Transparency" />
                <img className="apd-rectangle-50" src={about_us.AboutCost} alt="Webuildd Cost"/>
                <img className="apd-rectangle-51" src={about_us.Experience} alt="Webuildd Experience"/>
                <img className="apd-rectangle-52" src={about_us.Warranty} alt="Webuildd Warranty"/>
                <img className="apd-rectangle-53" src={about_us.Completion} alt="Webuildd Completion" />
                <img className="apd-rectangle-54" src={about_us.SOPC} alt="Webuildd SOPC" />


                <div className="apd-frame-29">
                  <div className="apd-place-1 apd-valign-text-middle apd-overpass-extra-bold-shark-32px">{place2}</div>
                  <p className="apd-text-3 apd-typography-body-smalltext-14-regular">{text128}</p>
                </div>
                <div className="apd-frame-29-1">
                  <div className="apd-transparenccy apd-valign-text-middle apd-overpass-extra-bold-shark-32px">{transparenccy}</div>
                  <p className="apd-text-4 apd-typography-body-smalltext-14-regular">{text129}</p>
                </div>
                <div className="apd-frame-29-2">
                  <div className="apd-cost-1 apd-valign-text-middle apd-overpass-extra-bold-shark-32px">{cost2}</div>
                  <p className="apd-text-5 apd-typography-body-smalltext-14-regular">{text130}</p>
                </div>
                <div className="apd-frame-29-3">
                  <div className="apd-place-1 apd-valign-text-middle apd-overpass-extra-bold-shark-32px">{About_Us_Text.Experience_Text_Head}</div>
                  <p className="apd-text-3 apd-typography-body-smalltext-14-regular">{About_Us_Text.Experience_Text}</p>
                </div>
                <div className="apd-frame-29-4">
                  <div className="apd-transparenccy apd-valign-text-middle apd-overpass-extra-bold-shark-32px">{About_Us_Text.Warranty_Text_Head}</div>
                  <p className="apd-text-4 apd-typography-body-smalltext-14-regular">{About_Us_Text.Warranty_Text}</p>
                </div>
                <div className="apd-frame-29-5">
                  <div className="apd-place-1 apd-valign-text-middle apd-overpass-extra-bold-shark-32px">{About_Us_Text.Completion_Text_Head}</div>
                  <p className="apd-text-3 apd-typography-body-smalltext-14-regular">{About_Us_Text.Completion_Text}</p>
                </div>
                <div className="apd-frame-29-6">
                  <div className="apd-transparenccy apd-valign-text-middle apd-overpass-extra-bold-shark-32px">{About_Us_Text.SOPC_Text_Head}</div>
                  <p className="apd-text-4 apd-typography-body-smalltext-14-regular">{About_Us_Text.SOPC_Text}</p>
                </div>
                 
                </div>
              </div>
              <div className="apd-group-157">
                <MultiCarousel/>
              <Footer />
            </div>
          </div>
          <NavBar />
        </div>
      </div>
      
    </div>
  );
}


function Group89(props) {
  const { line4, line5, line6, line7, line8 } = props;

  return (
    <div className="apd-group-89">
      {/* <img className="apd-line-4" src={line4} />
      <img className="apd-line" src={line5} />
      <img className="apd-line" src={line6} />
      <img className="apd-line" src={line7} />
      <img className="apd-line-8" src={line8} /> */}
    </div>
  );
}


function FounderCard(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apd-founder-card">
      <img className="apd-rectangle-90" src={rectangle90} /> 
      <div className="apd-group-99">
        <div className="apd-name valign-text-middle apd-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apd-designation apd-typography-body-smalltext-14-regular">{designation}</div>
      </div>
      
    </div>
  );
}


function FounderCard2(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apd-founder-card-1">
      <img className="apd-rectangle-90-1" src={rectangle90} />
      <div className="apd-group-99-1">
        <div className="apd-name-1 apd-valign-text-middle apd-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apd-designation-1 apd-typography-body-smalltext-14-regular">{designation}</div>
      </div> 

      
    </div>
  );
}


function FounderCard32(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apd-founder-card-2">
    
      <img className="apd-rectangle-90-2" src={rectangle90} />
      <div className="apd-group-99-2">
        <div className="apd-name-2 apd-valign-text-middle apd-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apd-designation-2 apd-typography-body-smalltext-14-regular">{designation}</div>
      </div>
      
    </div>
  );
}


function FounderCard4(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apd-founder-card-3">
      <img className="apd-rectangle-90-3" src={rectangle90} />
      <div className="apd-group-99-3">
        <div className="apd-name-3 apd-valign-text-middle apd-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apd-designation-3 apd-typography-body-smalltext-14-regular">{designation}</div>
      </div>
      
    </div>
  );
}


function Group156(props) {
  const { image2, image3, image4, image5, image6, image7 } = props;

  return (
    <div className="apd-group-156">
          <img className="apd-image-2" src={about_us.GreyBG1} />  
          <img className="apd-image" src={about_us.GreyBG2} />
          <img className="apd-image-4" src={about_us.GreyBG3} />
          <img className="apd-image" src={about_us.GreyBG4} />
          <img className="apd-image-6" src={about_us.GreyBG5} />
          <img className="apd-image" src={about_us.GreyBG6} />
    </div>
  );
}


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="apd-group-86">
      <White src={whiteProps.src} />
      <img className="apd-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="apd-white">
      <img className="apd-vector-45" src={src} />
    </div>
  );
}


function Group324() {
  return (
    <div className="apd-group-32">
      <div className="apd-group-189">
        <div className="apd-map-pin-1">
          <div className="apd-overlap-group1-2">
            <img
              className="apd-vector-46"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-167@2x.svg"
            />
          </div>
        </div>
        <p className="apd-text-6 apd-typographybody16-regular">
          #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
        </p>
      </div>
      <div className="apd-group-18">
        <div className="apd-phone">
          <img
            className="apd-vector-47"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-223@2x.svg"
          />
        </div>
        <div className="apd-text apd-valign-text-middle apd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
      </div>
      <div className="apd-group-18">
        <div className="apd-mail">
          <div className="apd-overlap-group1-3">
            <img
              className="apd-vector-48"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-170@2x.svg"
            />
          </div>
        </div>
        <div className="apd-text apd-valign-text-middle apd-typographybody16-regular">contact@webuild.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="apd-facebook-app-symbol">
      <img className="apd-f-1" src={src} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="apd-twitter">
      <img className="apd-vector-49" src={src} />
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="apd-frame-5">
      <div className="apd-text-9 apd-valign-text-middle apd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47 } = props;

  return (
    <div className="apd-frame-4">
      <div className="apd-text-7 apd-valign-text-middle apd-typographybody16-regular">{text41}</div>
      <div className="apd-text-8 apd-valign-text-middle apd-typographybody16-regular">{text42}</div>
      <div className="apd-text-8 apd-valign-text-middle apd-typographybody16-regular">{text43}</div>
      <div className="apd-text-8 apd-valign-text-middle apd-typographybody16-regular">{text44}</div>
      <div className="apd-text-8 apd-valign-text-middle apd-typographybody16-regular">{text45}</div>
      <div className="apd-text-8 apd-valign-text-middle apd-typographybody16-regular">{text46}</div>
      <div className="apd-text-8 apd-valign-text-middle apd-typographybody16-regular">{text47}</div>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="apd-frame-6">
      <div className="apd-text-17 apd-valign-text-middle apd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="apd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, className } = props;

  return (
    <div className={`apd-frame-4-1 ${className || ""}`}>
      <div className="apd-text-18 apd-valign-text-middle apd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="apd-frame-1580">
        <div className="apd-text-10 apd-valign-text-middle apd-typographybody16-regular">{text50}</div>
        <div className="apd-place-2 apd-valign-text-middle apd-typographybody16-regular">{place}</div>
        <div className="apd-text-20 apd-valign-text-middle apd-typographybody16-regular">{text51}</div>
        <div className="apd-text-21 apd-valign-text-middle apd-typographybody16-regular">{text52}</div>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="apd-frame-7">
      <div className="apd-text-25 apd-valign-text-middle apd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="apd-group-86-1">
      <White src={whiteProps.src} />
      <img className="apd-group-85-1" src={group85} />
    </div>
  );
}


function GetAQuoteButton22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i2601251964120TimelineData);
  }, []);

  return (
    <div className="apd-i26012519-64120 component apd-component-wrapper apd-not-ready">
      <div className="apd-master-button-LNtG5G">
        <div className="apd-button-i2601251964-tEWvkw apd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i2601251964120TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".i26012519-64120",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: whiteData,
};

const facebookAppSymbol3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-5@2x.svg",
};

const twitter3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-229@2x.svg",
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
};

const frame422Data = {
    text49: "Interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "apd-frame-5-1",
};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBEMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};


const white2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: white2Data,
};

const getAQuoteButton22Data = {
    children: "GET A QUOTE",
};



const x02AboutPageDesktopData = {
    text126: "WeBuildd is a third-generation family-owned construction company located in Bangalore. As a fully integrated firm, we have our in-house team of Architects, Structural Engineers, Contractors/Builders, Interior Designers, and Consultants to make your visions come true.",
    text1262: "With our strong technical knowledge in the construction industry, we have developed properties across all asset classes including, industrial, manufacturing, biotech, residential, healthcare, education, mixed‐use, and retail.",
    text1263: "We have invested countless hours in the relentless pursuit of building better and smart homes and commercial properties through our quality-conscious, money-saving, thoughtful designs, as well as transparent, higher building standards.",
    text1264: "Our objective has been to make the construction process enjoyable for our consumers since the beginning of our adventure.",
    text1265: "We give the customers the ability to personalize their visions from floor plans and construction materials to furniture cabinets at a price that fits their budget without compromising the quality.",
    text1266: "We also help our customers to sort through residential & commercial building requirements, ranging from government plan approvals, architectural plans, construction, io interior solutions.",
    text1267: "To begin your journey with us, use our online construction calculator to get a glimpse into our process and the financials involved.",
    aboutUs: "About Us",
    whyChooseUs: "Why Choose Us?",
    founders: "Founders",
    line55: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-55@1x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-177@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-178@2x.svg",
    place: "Quality",
    vector4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-7@2x.svg",
    vector5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-182@2x.svg",
    vector6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-9@2x.svg",
    vector7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-184@2x.svg",
    vector8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-11@2x.svg",
    vector9: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-12@2x.svg",
    vector10: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-187@2x.svg",
    vector11: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-14@2x.svg",
    vector12: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-189@2x.svg",
    vector13: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-190@2x.svg",
    vector14: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-17@2x.svg",
    vector15: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-192@2x.svg",
    vector16: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-193@2x.svg",
    vector17: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
    vector18: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-195@2x.svg",
    vector19: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-196@2x.svg",
    vector20: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-23@2x.svg",
    vector21: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-198@2x.svg",
    vector22: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-25@2x.svg",
    vector23: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-26@2x.svg",
    vector24: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-201@2x.svg",
    vector25: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-202@2x.svg",
    vector26: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-203@2x.svg",
    vector27: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-30@2x.svg",
    vector28: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-205@2x.svg",
    group: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-32@2x.svg",
    vector29: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-207@2x.svg",
    vector30: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-34@2x.svg",
    vector31: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-35@2x.svg",
    vector32: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-34@2x.svg",
    vector33: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-211@2x.svg",
    vector34: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-212@2x.svg",
    vector35: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-35@2x.svg",
    vector36: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-35@2x.svg",
    vector37: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-215@2x.svg",
    vector38: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-216@2x.svg",
    vector39: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-217@2x.svg",
    vector40: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-44@2x.svg",
    vector41: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-219@2x.svg",
    transparency: "Transparency",
    vector42: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-179@2x.svg",
    vector43: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-6@2x.svg",
    cost: "Cost",
    rectangle77: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-77@1x.png",
    howItWorks: "How it Works?",
    text127: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing. There are many variations passages of Lorem as Ipsums available but the majority have suffered that alterations in that some form by injected humour or randomised words which don’t looks even slightly that believable. If you are Lorem as Ipsum  you need to be sure there isn’t anything as embarrassing. There are many variation of passages Lorem Ipsum available but the majority have suffered that a aalteration in that some form by injected humour or randomised words which don’t look even slightly the believable. If you are Lorem Ipsum you need to be sure there is not the anything of embarrassing. If you are Lorem Ipsums your need to be sure there as isn’t anything embarrassing.",
    rectangle48: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-48-6@1x.png",
    rectangle49: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-49-6@1x.png",
    rectangle50: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-50-6@1x.png",
    place2: "Quality",
    text128: <>Quality for us, is not just using expensive brands of raw materials, it mainly involves three key points, <br /><ul><li>Right design.</li> <p>By understanding the geological condition of your site as a prerequisite, we provide the customized design for your homesite by adopting inputs from the soil testing that we perform for each construction site.</p><li>Right standard operating procedures.</li><p>Our SOPs ensure we achieve high efficiency, quality outputs, and uniformity of performance.</p><li>Customising the appropriate construction material for specific conditions.<p>  Each brand of construction material has its strengths and weaknesses. We provide suggestions at each stage for specific brands and types of material to use according to your unique condition.</p></li></ul></>,
    transparenccy: "Transparency",
    text129: <ul><li>Start your WeBuildd experience by visiting our existing projects of your choice.</li><li>You will receive an extensive list of ongoing and completed projects as a reference.</li><li>Every raw material and process performed at the start is described in an elaborate contract.</li><li> Selection option and final call in your hands. We will have you accompany us to the store for the closing call regarding the type of sanitary fittings, tiles, marbles, paint color, and all other interior items.</li></ul>,
    cost2: "Cost",
    text130: "We price you at the actuals, which means there is no premium or additional cost added from us.",
};

